import type { TUseRequestUpdaterProps } from 'features/request/useRequest';
import { useRequest } from 'features/request/useRequest';
import type { UerRatioRowDefaultsQuery } from 'gql/graphql';
import { RatioTypeEnum } from 'gql/graphql';

import type React from 'react';
import { useCallback, useMemo } from 'react';
import type { UseFormSetValue } from 'react-hook-form/dist/types/form';

import { uerRatioRowDefaultsGql } from '../createOrEditRatioQueries';

interface IUsePriceListUerForConstraintRatio {
    contractId: number;
    uerBaseRowId: number | null;
    isConstraintRatio: boolean;
    ratioRowId: number | null;
    setValue: UseFormSetValue<any>;
    setInitialGroupValue: React.Dispatch<any>;
}

const requestId = 'priceListUerForConstraintRatioEqCode';

export const usePriceListUerForConstraintRatio = (props: IUsePriceListUerForConstraintRatio) => {
    const { contractId, isConstraintRatio, ratioRowId, setInitialGroupValue, setValue, uerBaseRowId } = props;

    const variables = useMemo(
        () => ({
            contractId,
            ratioType: RatioTypeEnum.ConstraintCoef,
            uerBaseRowId,
        }),
        [contractId, uerBaseRowId],
    );

    const onSuccess = useCallback(
        (depsVars: TUseRequestUpdaterProps<UerRatioRowDefaultsQuery>) => {
            if (depsVars?.payload?.uerRatioRowDefaults?.data) {
                const item = depsVars?.payload?.uerRatioRowDefaults?.data;

                const ratioGroup = {
                    sectionId: item?.groupId,
                    sectionName: item?.groupName,
                    data: item,
                };

                if (item?.groupId) {
                    setInitialGroupValue(ratioGroup);

                    setValue('ratioGroup', ratioGroup);
                    setValue('ratioGroupId', item?.groupId);
                }
            }
        },
        [setInitialGroupValue, setValue],
    );

    const [, , , , setRatioDefaultsData] = useRequest({
        requestId,
        query: uerRatioRowDefaultsGql,
        variables,
        withEffect: Boolean(!ratioRowId && contractId && uerBaseRowId && isConstraintRatio),
        dependenciesUpdater: onSuccess,
    });

    return { priceListUerForConstraintRatioDataSetData: setRatioDefaultsData };
};
